var _circle, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXlsError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F4F7F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_81)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7958 5.33398H17.9355L23.9773 11.6406V23.8878C23.9773 25.4216 22.7394 26.6673 21.2055 26.6673H10.7958C9.26976 26.6673 8.02403 25.4216 8.02403 23.8878V8.10575C8.024 6.57972 9.26976 5.33398 10.7958 5.33398V5.33398Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9277 5.33398V11.5861H23.9773L17.9277 5.33398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6575 20.867H13.6219L12.9134 19.6758L12.2049 20.867H11.1616L12.3918 18.796L11.3096 16.9974H12.3528L12.9134 17.9317L13.4662 16.9974H14.5095L13.435 18.8038L14.6575 20.867ZM15.0234 20.867V16.9974H16.0122V20.0261H17.694V20.867H15.0234V20.867ZM19.329 20.9137C18.9397 20.9137 18.5971 20.7892 18.3013 20.5478C18.0132 20.3142 17.8497 20.0184 17.8263 19.668L18.675 19.4189C18.6984 19.6057 18.7762 19.7692 18.9086 19.8938C19.0487 20.0184 19.2044 20.0807 19.3757 20.0807C19.5159 20.0807 19.6327 20.0495 19.7261 19.9872C19.8117 19.9249 19.8584 19.8393 19.8584 19.7381C19.8584 19.6525 19.8195 19.5824 19.7494 19.5201C19.6793 19.4656 19.5859 19.4189 19.4769 19.3799C19.3679 19.341 19.2356 19.3021 19.1032 19.2709C18.9631 19.232 18.8229 19.1853 18.6905 19.123C18.5504 19.0685 18.4258 18.9984 18.3168 18.9128C18.2 18.8349 18.1144 18.7182 18.0443 18.5702C17.9742 18.4301 17.9353 18.2588 17.9353 18.0641C17.9353 17.7449 18.0677 17.4802 18.3402 17.27C18.6127 17.052 18.9397 16.9507 19.3212 16.9507C19.7027 16.9507 20.0375 17.0442 20.3178 17.2233C20.5981 17.4101 20.7771 17.6515 20.8472 17.9473L19.9596 18.3211C19.9207 18.1576 19.8428 18.0252 19.7338 17.924C19.6248 17.8306 19.4847 17.7761 19.3212 17.7761C19.1966 17.7761 19.1032 17.8072 19.0253 17.8539C18.9552 17.9006 18.9241 17.9707 18.9241 18.0564C18.9241 18.1342 18.9708 18.2043 19.0642 18.2588C19.1577 18.3055 19.2823 18.3444 19.4224 18.3678C19.5625 18.3912 19.7182 18.4301 19.8817 18.4846C20.053 18.5469 20.201 18.6092 20.3489 18.6948C20.489 18.7727 20.6058 18.905 20.6993 19.0763C20.8005 19.2554 20.8472 19.4656 20.8472 19.707C20.8472 20.0651 20.707 20.361 20.4267 20.579C20.1464 20.797 19.7806 20.9137 19.329 20.9137V20.9137Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 8,
    r: 3.33333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5371 4.4631C22.5862 2.5126 19.4135 2.5126 17.4626 4.4631C15.5125 6.41361 15.5125 9.58716 17.4626 11.5377C18.438 12.5127 19.719 13 21.0001 13C22.2811 13 23.5617 12.5127 24.5371 11.5377C26.4876 9.58718 26.4876 6.41361 24.5371 4.4631ZM23.0631 9.4742C23.2261 9.63719 23.2261 9.90065 23.0631 10.0636C22.9818 10.1449 22.8751 10.1858 22.7684 10.1858C22.6617 10.1858 22.5549 10.1449 22.4736 10.0636L21 8.58961L19.5269 10.0632C19.4452 10.1445 19.3384 10.1854 19.2321 10.1854C19.1254 10.1854 19.0187 10.1445 18.9374 10.0632C18.7744 9.90022 18.7744 9.63635 18.9374 9.47377L20.4106 8.00017L18.937 6.52657C18.774 6.36358 18.774 6.09971 18.937 5.93713C19.0996 5.77415 19.3634 5.77415 19.5264 5.93713L21 7.41073L22.4736 5.93713C22.6366 5.77415 22.9001 5.77415 23.0631 5.93713C23.2261 6.09971 23.2261 6.36358 23.0631 6.52657L21.5895 8.00017L23.0631 9.4742Z",
    fill: "#FC1111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(5.33398 5.33398)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(16 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsError);
export default __webpack_public_path__ + "static/media/xls-error.b922735d.svg";
export { ForwardRef as ReactComponent };